import request from "@/utils/request";
import qs from "qs";

// 查询代理商配置列表
export function getAgentConfigList(params) {
  return request({
    url: "/agentWithdraw/getAgentWithdrawInfoList",
    method: "get",
    params
  });
}

// 审核代理商提现
export function checkWithdraw(params) {
  return request({
    url: "/agentWithdraw/reviewAgentWithdraw",
    method: "get",
    params
  });
}

// 转账凭证上传
export function uploadFileWithdraw(params) {
  return request({
    url: "/agentWithdraw/updateAgentWithdraw",
    method: "get",
    params
  });
}

// 查询代理商配置列表
export function getAgentWithdrawInfoList(params) {
  return request({
    url: "/agentConfig/getAgentConfigList",
    method: "get",
    params
  });
}

// 新增代理商配置
export function addAgentConfig(params) {
  return request({
    url: "/agentConfig/addAgentConfig",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 修改代理商配置
export function updateAgentConfig(params) {
  return request({
    url: "/agentConfig/updateAgentConfig",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 删除代理商配置
export function deleteAgentConfig(params) {
  return request({
    url: "/agentConfig/deleteAgentConfig",
    method: "get",
    params
  });
}

export function reviewAgentWithdraw(params) {
  return request({
    url: "/agentWithdraw/reviewAgentWithdraw",
    method: "get",
    params
  });
}

// 查询代理商合伙人列表
export function getAgentPartnerList(params) {
  return request({
    url: "/agentPartner/getAgentPartnerList",
    method: "get",
    params
  });
}

// 修改代理合伙人比例
export function updateAgentPartnerRatio(params) {
  return request.post("/agentPartner/updateAgentPartner", qs.stringify(params));
}

// 查询区域代理列表
export function getAgentList1027(params) {
  return request({ url: "/agentPartner/getAgentList/1027", method: "get", params });
}

// 旧地区接口保留，避免影响其他页面。
export function getAgentPartnerAreaList(params) {
  return request({
    url: "/agentPartner/getAgentList",
    method: "get",
    params
  });
}

// 查询代理商合伙人列表
export function addAgentPartnerArea(params) {
  return request.post("/agentPartner/addAgentPartner", qs.stringify(params));
}

// 代理商人工提现
export function agentManualWithdraw(params) {
  return request.post("/agentWithdraw/agentManualWithdraw", qs.stringify(params));
}

